import { Button } from "../../../components";
import { notification } from "../../../services";

const ImportarPessoasActions = ({
  steps,
  activeStep,
  setActiveStep,
  isCadastro,
  setIsCadastro,
  setLoading,
}) => {
  const handleVoltarStep = () => {
    if (activeStep > 0) {
      setActiveStep(activeStep - 1);
      setIsCadastro(false);
    }
  };

  const handleAvancarStep = async () => {
    setLoading(true);
    try {
      let proximoStep = activeStep + 1;
      await steps[activeStep]?.funcaoAcao();
      if (proximoStep < steps.length) setActiveStep(proximoStep);
    } catch (error) {
      notification.alertaGenericos(
        error.message || "Ocorreu um erro inesperado."
      );
    } finally {
      setLoading(false);
    }
  };

  const switchCadastros = () => {
    switch (activeStep) {
      default:
        return handleAvancarStep();
    }
  };

  return (
    <>
      <Button
        variant="contained"
        onClick={handleVoltarStep}
        sx={{ width: "130px" }}
        startIcon={
          <i
            className="ph-fill ph-caret-left"
            style={{ color: "#fff", fontSize: 18 }}
          ></i>
        }
        disabled={activeStep === 0}
      >
        Voltar
      </Button>
      {isCadastro ? (
        <Button
          variant="contained"
          color="success"
          onClick={switchCadastros}
          sx={{ width: "135px" }}
          endIcon={
            activeStep === 3 && (
              <i
                className="ph-fill ph-caret-right"
                style={{ color: "#fff", fontSize: 18 }}
              ></i>
            )
          }
        >
          Cadastrar
        </Button>
      ) : (
        <Button
          variant="contained"
          onClick={handleAvancarStep}
          sx={{ width: "135px" }}
          endIcon={
            <i
              className="ph-fill ph-caret-right"
              style={{ color: "#fff", fontSize: 18 }}
            ></i>
          }
        >
          Próximo
        </Button>
      )}
    </>
  );
};

export default ImportarPessoasActions;
